import AlgoliaSearch from './AlgoliaSearch';

export default AlgoliaSearch;
